// The cookie banner stores its choice in three cookies:
// - acceptedTrackers: the tracking pixels allowed by the analytics and marketing categories.
// - acceptedFunctional: 1 when embedded content is allowed, 0 when not.
// - consentVersion: the banner version it was made on. On another version the
//   banner is shown again, and the stored choice applies until it is answered.
// The original two-button banner only wrote acceptedTrackers and never asked
// about embedded content, so its "Accept" does not count as consent for it.
const readCookie = (name) => document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`))?.[1] ?? null;

export const FUNCTIONAL_ACCEPTED_EVENT = 'functionalCookiesAccepted';

export function acceptedTrackers() {
    return (readCookie('acceptedTrackers') ?? '').split(',').filter(Boolean);
}

export function functionalCookiesAccepted() {
    return readCookie('acceptedFunctional') === '1';
}

// Runs callback now if functional cookies are already accepted, otherwise as
// soon as they are accepted in the banner. Returns a function that stops listening.
export function onFunctionalCookiesAccepted(callback) {
    if (functionalCookiesAccepted()) {
        callback();
        return () => {};
    }

    window.addEventListener(FUNCTIONAL_ACCEPTED_EVENT, callback, { once: true });

    return () => window.removeEventListener(FUNCTIONAL_ACCEPTED_EVENT, callback);
}
